import { Component, Input, OnInit, OnChanges, AfterViewInit, ViewChild, ElementRef  } from '@angular/core';
import { Router } from '@angular/router';
import { CookiesService } from 'src/app/CookieService';
import { FavouriteIconComponent } from 'src/app/shared/favourite-icon/favourite-icon.component';

@Component({
    selector: 'app-nearby-site-widget',
    templateUrl: './nearby-site-widget.component.html',
    styleUrls: ['./nearby-site-widget.component.scss'],
})
export class NearbySiteWidgetComponent implements OnInit, OnChanges, AfterViewInit {

	@Input() identifier : string;
	@Input() siteName : string;
	@Input() sitePhoto : string;
	@Input() distanceM : number;
	@Input() isFavourite : boolean;
	@ViewChild("favouriteIcon", { read : ElementRef }) favouriteIconElementRef : ElementRef;

	@ViewChild(FavouriteIconComponent) favouriteIconComp : FavouriteIconComponent;

	constructor(private router : Router)
	{

	}

	ngOnInit() : void {

	}

	ngOnChanges() : void {

	}

	ngAfterViewInit(): void {
		
	}

	onCardClicked = (event : any) => {
		const pos = {
			x: event.targetTouches ? event.targetTouches[0].pageX: event.pageX,
			y: event.targetTouches ? event.targetTouches[0].pageY  : event.pageY
		};
		const rect = this.favouriteIconElementRef?.nativeElement?.getBoundingClientRect();	
		const left = rect.left + document.documentElement.scrollLeft;
		const top = rect.top + document.documentElement.scrollTop;

		if(this.favouriteIconElementRef?.nativeElement?.contains(event.target) ||
			(pos.x >= left && pos.x <= left + rect.width && pos.y >= top && pos.y <= top + rect.height))
		{
			event.preventDefault();
			this.favouriteIconComp?.toggleFavourite(event);
			return false;
		}
		this.router.navigate(['/siteDetails', this.identifier]);
		//"function" === typeof(event.stopPropogation) && event.stopPropogation();		
		return true;
	}

	get siteImage(): string {    
		const img = this.sitePhoto ?? "assets/images/SiteDetails/Default_img_web.png";
		return img;
	}
}
